// extracted by mini-css-extract-plugin
module.exports = {"section":"partnerList_section__pOzEV","hide":"partnerList_hide__Lk_O0"};